import { Helmet } from "react-helmet-async";

export default function NoIndex({ title }) {
  return (
    <Helmet>
      <title>{title ? `${title} · Anthony's Playworld` : "Anthony's Playworld"}</title>
      <meta name="robots" content="noindex,nofollow" />
    </Helmet>
  );
}
